var render = function render(){var _vm=this,_c=_vm._self._c;return _c('text-input',{ref:"input",attrs:{"label":_vm.label,"originalValue":_vm.content,"maxlength":1000000},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }